import type { ElementDisponibleType } from '@/types';

export const RECU_MAIL_ELEMENTS_DISPONIBLES: ElementDisponibleType[] = [
  {
    libelle: 'Civilité du payeur',
    valeur: '{Civilite_payeur}',
    icon: 'VenusAndMars',
  },
  {
    libelle: 'Nom du payeur',
    valeur: '{Nom_payeur}',
    icon: 'User',
  },
  {
    libelle: 'Numéro du reçu',
    valeur: '{Numero_recu}',
    icon: 'Hash',
  },
  {
    libelle: 'Montant du reçu',
    valeur: '{Montant_recu}',
    icon: 'Euro',
  },
  {
    libelle: 'Date du reçu',
    valeur: '{Date_recu}',
    icon: 'Calendar',
  },
  {
    libelle: 'Nom de la régie',
    valeur: '{Nom_regie}',
    icon: 'Building',
  },
  {
    libelle: 'Factures concernées',
    valeur: '{Factures_concernees}',
    icon: 'FileText',
  },
  {
    libelle: 'Adresse de la régie',
    valeur: '{Adresse_regie}',
    icon: 'MapPin',
  },
  {
    libelle: 'Téléphone de la régie',
    valeur: '{Telephone_regie}',
    icon: 'Phone',
  },
  {
    libelle: 'Courriel de la régie',
    valeur: '{Courriel_regie}',
    icon: 'Mail',
  },
  {
    libelle: "Horaires d'ouverture",
    valeur: '{Horaires_ouverture}',
    icon: 'Clock',
  },
  {
    libelle: 'Nom du régisseur',
    valeur: '{Nom_regisseur}',
    icon: 'UserCheck',
  },
  {
    libelle: 'Type de régisseur',
    valeur: '{Type_regisseur}',
    icon: 'BadgeCheck',
  },
];
